var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.38,
    height: 39.555,
    viewBox: "0 0 42.38 39.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "audio-x-generic-svgrepo-com",
    d: "M22.6,1a8.521,8.521,0,0,0-8.476,8.476V21.749a9.789,9.789,0,0,0-4.238-.971,9.889,9.889,0,1,0,9.889,9.944V9.476A2.789,2.789,0,0,1,22.6,6.651H33.9A2.789,2.789,0,0,1,36.73,9.476V21.749a9.789,9.789,0,0,0-4.238-.971,9.889,9.889,0,1,0,9.889,9.889V9.476A8.521,8.521,0,0,0,33.9,1ZM9.889,26.428a4.2,4.2,0,0,1,4.238,4.238v.044a4.238,4.238,0,1,1-4.238-4.282Zm22.6,0a4.238,4.238,0,1,1-4.238,4.238A4.2,4.2,0,0,1,32.492,26.428Zm0,0",
    transform: "translate(0 -1)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMp3);
export default __webpack_public_path__ + "static/media/mp3.373a4228d08e9b58be434955f312184f.svg";
export { ForwardRef as ReactComponent };